(function (window, document, $) {

    $(document).ready(function () {
        // Update YogaTV comments section to get around full-page caching ===============================================================

        function updateYogaTVComments() {
            if ($('.video-content-main__comments').length < 1) {
                return;
            }

            var id = themevars.postID;

            $.ajax({
                url: themevars.ajaxurl,
                data: {
                    action: 'ym_get_video_comments',
                    postid: id
                },
                type: 'POST',
                dataType: 'json'
            }).done(function (result) {
                if (true !== result.success || undefined === result.data.showcommentsform) {
                    $('.video-content-main__comments .button-collapse').remove();
                    $('.video-content-main__comments .comment-form__wrapper').remove();
                    $('.video-content-main__comments .comment-reply-link').remove();
                    $('.video-content-main__comments .comment-login-required-text').removeClass('d-none');
                    return;
                }

                $('.video-content-main__comments .button-collapse').show();
                $('.video-content-main__comments .comment-form__wrapper').show();
                $('.video-content-main__comments .comment-reply-link').show();
            });
        }

        updateYogaTVComments();


        // load more comments button click event
        $('.comment_loadmore').click(function () {
            var button = $(this);

            // decrease the current comment page value
            cpage--;

            $.ajax({
                url: themevars.ajaxurl, // AJAX handler, declared before
                data: {
                    'action': 'cloadmore', // wp_ajax_cloadmore
                    'post_id': parent_post_id, // the current post
                    'cpage': cpage, // current comment page
                },
                type: 'POST',
                beforeSend: function (xhr) {
                    button.text('Loading...'); // preloader here
                },
                success: function (data) {
                    if (data) {
                        $('.comments-list').append(data);
                        button.text('Toon meer reacties');

                        // if reply form is not present remove reply links from new comments
                        if (!$('.comment-form__wrapper').length) {
                            $('.comment-reply-link').remove();
                        }

                        // if the last page, remove the button
                        if (cpage == 1) {
                            button.remove();
                        }
                    } else {
                        button.remove();
                    }
                }
            });
            return false;
        });
    });

}(window, document, jQuery));
